<template>
    <div class="grid place-items-center rounded-[var(--radius-md)] border border-dashed border-border bg-secondary/40 py-8 text-sm text-muted-foreground cursor-pointer"
        @click="inputRef?.click()" @dragover.prevent @drop.prevent="handleDrop">
        <input ref="inputRef" type="file" class="hidden" :accept="accept" @change="handleChange" />
        <template v-if="file">
            <div class="flex items-center gap-2">
                <img v-if="previewUrl" :src="previewUrl" :alt="file.name" class="h-10 w-10 rounded object-contain" />

                <span class="truncate">{{ file.name }}</span>

                <button type="button" class="shrink-0 text-[var(--danger)]" @click.stop="removeFile">
                    ×
                </button>
            </div>
        </template>

        <template v-else>
            برای بارگذاری کلیک کنید یا فایل را اینجا رها کنید
        </template>
    </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    accept?: string
    modelValue?: File | null
  }>(),
  {
    accept: 'image/*,.pdf',
    modelValue: null,
  }
)

const emit = defineEmits<{
  'update:modelValue': [file: File | null]
}>()

const inputRef = ref<HTMLInputElement | null>(null)
const file = ref<File | null>(props.modelValue)
const previewUrl = ref<string | null>(null)

function updatePreview(selectedFile: File | null) {
  if (previewUrl.value) {
    URL.revokeObjectURL(previewUrl.value)
    previewUrl.value = null
  }

  if (selectedFile?.type.startsWith('image/')) {
    previewUrl.value = URL.createObjectURL(selectedFile)
  }
}

function setFile(selectedFile: File | null) {
  file.value = selectedFile
  updatePreview(selectedFile)
  emit('update:modelValue', selectedFile)
}

function handleChange(event: Event) {
  const input = event.target as HTMLInputElement
  setFile(input.files?.[0] ?? null)
}

function handleDrop(event: DragEvent) {
  setFile(event.dataTransfer?.files?.[0] ?? null)
}

function removeFile() {
  setFile(null)

  if (inputRef.value) {
    inputRef.value.value = ''
  }
}

watch(
  () => props.modelValue,
  (value) => {
    if (value !== file.value) {
      file.value = value || null
      updatePreview(file.value)
    }
  }
)

onBeforeUnmount(() => {
  if (previewUrl.value) {
    URL.revokeObjectURL(previewUrl.value)
  }
})
</script>